//export const BaseUrl="http://127.0.0.1:8000/api/"

export const BaseUrl="http://3.13.249.184/api/"


export const LoginUrl = BaseUrl+ "user/login"
export const MeUrl = BaseUrl + "user/Me"
export const CreateUserUrl = BaseUrl + "user/create-user"
export const UsersUrl = BaseUrl + "user/users"
export const UpdatePasswordUrl = BaseUrl + "user/update-password"
export const ForgotPasswordUrl = BaseUrl + "user/ForgotPasswordView"
export const ResetPasswordUrl = BaseUrl + "user/ResetPasswordView"
// Case Management URLs (Legacy - to be removed)
export const CasesUrl = BaseUrl + "masterdata/cases/"
export const CaseStatisticsUrl = BaseUrl + "masterdata/case-details/statistics/"
export const CaseOutcomeAnalyticsUrl = BaseUrl + "masterdata/cases/outcome_analytics/"
export const QLetterCasesUrl = BaseUrl + "masterdata/cases/q_letter_cases/"
export const InfoForLetterCasesUrl = BaseUrl + "masterdata/cases/info_for_letter_cases/"

// New Case Management URLs
export const CaseNumbersUrl = BaseUrl + "masterdata/case-numbers/"
export const CaseDetailsUrl = BaseUrl + "masterdata/case-details/"

// Scoring Questions URLs
export const CaseScoringQuestionsUrl = BaseUrl + "masterdata/case-scoring-questions/"
export const CategoryWeightagesUrl = BaseUrl + "masterdata/category-weightages/"
export const LikelihoodScoresUrl = BaseUrl + "masterdata/likelihood-scores/"

// References URLs
export const ReferencesUrl = BaseUrl + "masterdata/references/"



